<template>
  <div id="boton-captura">
    <v-container grid-list-xl fluid>
      <v-flex lg12>
        <v-card>
          <boton-proceso-tab-cap :lstBtn="lstBtn"></boton-proceso-tab-cap>
        </v-card>
        <div v-if="loading">
          <loading></loading>
        </div>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import Material from "vuetify/es5/util/colors";
import BotonProcesoTabCap from "@/modules/configuration/commonsviews/BotonProcesoTabCaptura.vue";
import Loading from "@/views/ui/Loading.vue";

export default {
  name: "boton-captura",

  components: {
    MiniStatistic,
    BotonProcesoTabCap,
    Loading,
  },
  data: () => ({
    color: Material,
    iconoBoton: "fa-print",
    tituloBoton: "Recepcion",
    colorBoton: "yellow darken-4",
    lstBtn: [],
    lstBtnCompleta: [
      {
        icon: "system_update_alt",
        title: "Recepcion",
        subtitle: "",
        color: "yellow darken-3",
        class: "recepcion rombo elevation-10",
        tab: "Recepcion",
        subPro: "RECEPCION", //valor para subproceso en BotonProcesoTabCaptura.vue
      },
      {
        icon: "format_line_spacing",
        title: "Seguimiento",
        subtitle: "",
        color: "teal",
        class: "seguimiento rombo elevation-10",
        tab: "Scan",
        subPro: "SEGUIMIENTO",
      },
      {
        icon: "ballot",
        title: "Cuadratura",
        subtitle: "",
        color: "blue darken-3",
        class: "cuadratura rombo elevation-10",
        tab: "Cuadratura Curso",
        subPro: "CUADRATURA",
      },
      /* Ocultamos el modulo de Destruccion
     {
        icon: "how_to_vote",
        title: "Destruccion",
        subtitle: "",
        color: "purple darken-2",
        class: "reportes elevation-10"
      },*/
      {
        icon: "business",
        title: "Administrativo",
        subtitle: "",
        color: "yellow darken-3",
        class: "recepcion rombo elevation-10",
        tab: "Administrativo",
        subPro: "ADMINISTRATIVO",
      },
      {
        icon: "assessment",
        title: "Prod&Report",
        subtitle: "",
        color: "purple",
        class: "reportes rombo elevation-10",
        tab: "Reportes",
        subPro: "REPORTES",
      },
    ],
  }),
  computed: {},
  Mounted() {},
  created() {
    this.loadDataPanelControl();
  },
  methods: {
    async loadDataPanelControl() {
      this.loading = true;
      let lstBtnTmp = await this.loadPanelControl();
      for (let i = 0; i < lstBtnTmp.length; i++) {
        this.lstBtn.push(this.lstBtnCompleta[lstBtnTmp[i] - 1]);
      }
      this.loading = false;
    },
    async loadPanelControl() {
      return await axios
        .get(
          "/panelControl/posicionActivos/" + this.$store.getters.contratoStored
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log("error loadPanelControl:" + error);
        });
    },
  },
};
</script>
